module.exports = __webpack_public_path__ + "static/media/nba-league-pass.e11802c9.jpg";